/**
 * Mayceline Loved on socials — muted autoplay for all in-view reels.
 * IntersectionObserver on section; iOS-safe muted+playsinline retry on gesture.
 */
(function () {
  function initSection(section) {
    if (!section || section.dataset.lovedInit === '1') return;
    section.dataset.lovedInit = '1';

    var cards = section.querySelectorAll('[data-loved-card]');
    if (!cards.length) return;

    var inView = false;
    var gestureBound = false;

    function setPlaying(card, playing) {
      if (playing) card.classList.add('is-playing');
      else card.classList.remove('is-playing');
    }

    function playCard(card) {
      var v = card.querySelector('video');
      if (!v) return;
      try {
        v.muted = true;
        v.defaultMuted = true;
        v.setAttribute('muted', '');
        v.playsInline = true;
      } catch (e) {}
      var p = v.play();
      if (p && typeof p.then === 'function') {
        p.then(function () {
          setPlaying(card, true);
        }).catch(function () {
          setPlaying(card, false);
        });
      } else {
        setPlaying(card, !v.paused);
      }
    }

    function pauseCard(card) {
      var v = card.querySelector('video');
      if (v) {
        try {
          v.pause();
        } catch (e) {}
      }
      setPlaying(card, false);
    }

    function playAll() {
      cards.forEach(playCard);
    }

    function pauseAll() {
      cards.forEach(pauseCard);
    }

    function bindGestureRetry() {
      if (gestureBound) return;
      gestureBound = true;
      var once = function () {
        if (inView) playAll();
        document.removeEventListener('touchstart', once, true);
        document.removeEventListener('click', once, true);
      };
      document.addEventListener('touchstart', once, true);
      document.addEventListener('click', once, true);
    }

    cards.forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;
      v.addEventListener('play', function () {
        setPlaying(card, true);
      });
      v.addEventListener('pause', function () {
        setPlaying(card, false);
      });
      // Optional: tap toggles mute-free pause/play for that card only
      card.addEventListener('click', function () {
        if (v.paused) playCard(card);
        else pauseCard(card);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              inView = true;
              playAll();
              bindGestureRetry();
            } else {
              inView = false;
              pauseAll();
            }
          });
        },
        { threshold: 0.3 }
      );
      observer.observe(section);
    } else {
      inView = true;
      playAll();
      bindGestureRetry();
    }
  }

  function boot() {
    document.querySelectorAll('[data-loved-socials]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      var s = e.target.querySelector('[data-loved-socials]') || e.target;
      if (s && s.hasAttribute && s.hasAttribute('data-loved-socials')) {
        s.dataset.lovedInit = '';
        initSection(s);
      }
    }
  });
})();
